import { render, staticRenderFns } from "./AboutXc.vue?vue&type=template&id=2e88b696&scoped=true&"
import script from "./AboutXc.vue?vue&type=script&lang=js&"
export * from "./AboutXc.vue?vue&type=script&lang=js&"
import style0 from "./AboutXc.vue?vue&type=style&index=0&id=2e88b696&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88b696",
  null
  
)

export default component.exports